import React, { useState } from 'react';

export default function Log() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [username, setUsername] = useState('');
  const [network, setNetwork] = useState('');
  const [startOption, setStartOption] = useState('');

  return (
    <div className="min-h-screen bg-zinc-100 flex flex-col md:flex-row justify-center items-center px-6 py-12 gap-8">
      
      {/* Left Side */}
      <div className="w-full bg-white max-w-md border rounded-2xl shadow p-6 space-y-4">
        <h2 className="text-xl font-semibold text-center text-blue-600">Welcome to Moodeng Credit</h2>

        <button className="w-full bg-orange-500 text-white py-2 rounded-lg hover:bg-orange-600 transition">
          Continue with Metamask
        </button>

        <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition">
          Continue with Google
        </button>

        <div className="flex items-center gap-2 text-gray-400 text-sm justify-center">
          <hr className="w-1/4 border" />
          <span>OR</span>
          <hr className="w-1/4 border" />
        </div>

        <div className="flex">
          <input
            type="email"
            placeholder="your_email@moodeng.com"
            className="w-full border px-3 py-2 rounded-l-md"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="bg-white text-blue-600 border border-l-0 px-4 rounded-r-md font-semibold">
            VERIFY
          </button>
        </div>

        <input
          type="password"
          placeholder="Password"
          className="w-full border px-3 py-2 rounded-md"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <input
          type="password"
          placeholder="Confirm Password"
          className="w-full border px-3 py-2 rounded-md"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />

        <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition">
          Register
        </button>

        <p className="text-center text-sm text-gray-400">
          Terms × Privacy × Docs
        </p>
      </div>

      {/* Right Side */}
      <div className="w-full bg-white max-w-md border rounded-2xl shadow p-6 space-y-5">
        <h2 className="text-xl font-semibold text-center text-blue-600">Welcome to Moodeng Credit</h2>

        <input
          type="text"
          placeholder="@username"
          className="w-full border px-3 py-2 rounded-md"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <div>
          <label className="block text-sm text-gray-600 mb-1">Set Default Network</label>
          <select
            className="w-full border px-3 py-2 rounded-md"
            value={network}
            onChange={(e) => setNetwork(e.target.value)}
          >
            <option>Choose Default Network</option>
            <option>Ethereum</option>
            <option>Polygon</option>
            <option>Sepolia</option>
          </select>
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">Where do you want to start?</label>
          <select
            className="w-full border px-3 py-2 rounded-md"
            value={startOption}
            onChange={(e) => setStartOption(e.target.value)}
          >
            <option>Lending or Borrowing</option>
            <option>Lending</option>
            <option>Borrowing</option>
          </select>
        </div>

        <p className="text-center text-sm text-gray-400">
          Terms × Privacy × Docs
        </p>
      </div>
    </div>
  );
}
